import { ResolveFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { catchError, EMPTY } from 'rxjs';
import { AcademicService } from '../dashboard/services/academic.service';

export const academicResolver: ResolveFn<any> = (route, state) => {
  const service = inject(AcademicService);
  const router = inject(Router);
  
  const slug = route.paramMap.get('slug');
  return service.getPublicAcademicDetailBySlug(slug!).pipe(
    catchError((error) => {
      console.error('Resolver error:', error);

      // Redirect to 404 page
      router.navigate(['/not-found']);

      return EMPTY;
    })
  );
};
